module.exports = "<div bind-html-compile=\"vm.content\" rf=\"{{vm.objectContentRf}}\"></div>\n";